import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '../../helpers/api-helper';
import KnowledgeBaseApi from '../../../infrastructure/knowledge-base-api';
export const createKnowledgeBaseAsync = createAsyncThunk('knowledgeBase/create', async (knowledgeBase, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await KnowledgeBaseApi.createKnowledgeBase(knowledgeBase);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getKnowledgeBasesAsync = createAsyncThunk('knowledgeBase/getAll', async (companyId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await KnowledgeBaseApi.getKnowledgeBases(companyId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getKnowledgeBaseByIdAsync = createAsyncThunk('knowledgeBase/getById', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await KnowledgeBaseApi.getKnowledgeBaseById(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateKnowledgeBaseAsync = createAsyncThunk('knowledgeBase/update', async ({ id, data }, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await KnowledgeBaseApi.updateKnowledgeBase(id, data);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteKnowledgeBaseAsync = createAsyncThunk('knowledgeBase/delete', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await KnowledgeBaseApi.deleteKnowledgeBase(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
